/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  TaxErrorNotification.tsx
 *
 * Project Title :  Checkout
 *
 * Description	:
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Sandeep Raja (E807238)
 *
 * @Date         : Nov 20, 2019
 *
 * @Version      : Version 1.0
 * 
 * By            : H224423
 * On            : Dec 17 2019
 * Description   : UT Automation 
 * 
 ******************************************************************************/

import * as React from 'react';
import { Grid, Notification } from '@scuf/common';

export const TaxErrorNotification = (props) => {
  return (
    <Grid.Row>
      <Grid.Column width={12}>
        <Notification
          className="tax-error-notification-bar"
          hasIcon={true}
          title="We're currently experiencing technical difficulties to fetch tax information."
          severity={props.severity}
          detailsText="RELOAD THE PAGE"
          onDetailsClick={() => window.location.reload()}
          // TODO: Need to implement/change onCloseClick() functionality
          // onCloseClick={() => window.location.reload()}
        >
            Please try after sometime. If issue still persists, please Honeywell support at <a href="mailto:dsa@honeywellaerospace.com">dsa@honeywellaerospace.com</a>
      (or) call us at <a href="tel:602-436-6738">602-436-6738</a>. 
        </Notification>
      </Grid.Column>
    </Grid.Row>
  );
};